import { PayloadAction } from '@reduxjs/toolkit'
import {
  DARK,
  UPDATE_THEME
} from '../../constants'
import { UserSettings } from '../../type/userSettings'

export const initialState: UserSettings = {
  theme: DARK
}

export function settingsReducer(
  state: UserSettings = initialState,
  action: PayloadAction<any>
): UserSettings {
  switch (action.type) {
    case UPDATE_THEME: {
      return {
        ...state,
        theme: action.payload.theme

      }
    }
    default:
      return state
  }
}
